var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close 1",
    clipPath: "url(#clip0_2491_183935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Close",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88517 5.99526L11.7813 0.979707C11.8883 0.86931 11.9474 0.721143 11.9458 0.56742C11.9442 0.413697 11.882 0.266791 11.7727 0.158648C11.7187 0.105178 11.6547 0.0629666 11.5843 0.0343923C11.5139 0.00581795 11.4385 -0.00851001 11.3625 -0.0077864C11.2866 -0.00706279 11.2115 0.00870958 11.1416 0.0386196C11.0718 0.0685297 11.0086 0.11195 10.9556 0.166438L6.06803 5.17425L0.978125 0.158648C0.924116 0.105225 0.860076 0.063032 0.789675 0.0344873C0.719275 0.00594249 0.643917 -0.00836737 0.567953 -0.0076439C0.491989 -0.00692043 0.416906 0.00883418 0.347062 0.0387146C0.277218 0.0685951 0.213993 0.111996 0.161011 0.166438C0.0539236 0.276733 -0.00533709 0.42486 -0.00388 0.578583C-0.00242292 0.732305 0.0596181 0.879204 0.168777 0.987449L5.25129 5.99526L0.168777 11.0031C0.0596181 11.1113 -0.00242292 11.2583 -0.00388 11.412C-0.00533709 11.5657 0.0539236 11.7138 0.161011 11.8241C0.213939 11.8787 0.27714 11.9222 0.346991 11.9521C0.416841 11.982 0.49196 11.9978 0.567953 11.9985C0.643946 11.9993 0.719315 11.9849 0.789723 11.9563C0.860131 11.9277 0.924168 11.8854 0.978125 11.8319L6.06803 6.81632L10.9556 11.8241C11.0092 11.8795 11.0734 11.9236 11.1444 11.9537C11.2154 11.9837 11.2917 11.9992 11.3688 11.9992C11.444 11.9995 11.5185 11.9849 11.588 11.9561C11.6574 11.9274 11.7205 11.8852 11.7735 11.8319C11.8828 11.7237 11.9449 11.5769 11.9465 11.4232C11.9481 11.2694 11.889 11.1213 11.7821 11.0109L6.88517 5.99526Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2491_183935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9526,
    height: 12.0001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.1613d8c0674a5bee746fefdc3d8d22b7.svg";
export { ForwardRef as ReactComponent };